import React, { Component } from 'react'
import { Radio, Input, AutoComplete, Button, Table, Popover, Icon, Select, Row, Col, Pagination } from 'antd'
import AddNoSystemPerson from './AddNoSystemPerson'
import { bind } from 'file-loader'
import { app, api } from '../../../app'

const RadioGroup = Radio.Group
const Option = Select.Option


class AddTeamMembers extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let Editor = 1
        if (props.Editor != undefined) {
            Editor = 2
        }

        //审核

        this.state = {
            //【radio单选框】
            addTeamPage: 1, //当前所渲染的组件
            //【radio单选框end】


            //【input组件】
            // 搜索队伍列表
            teamList: [],
            // 搜索队伍列表end

            // 第一个搜索按钮
            searchTeamnoValue: '',
            searchTeamno: '',   //队伍编号(配合第一个input框搜索使用)
            // 第一个搜索按钮end

            // 搜索队员列表
            memberList: [],
            search_memberval: '',
            // 搜索队员列表end
            //【input组件】

            // 【table数据展示】
            data: [],   //根据搜索按钮所获取到的搜索队员信息，table1
            addTeamPersonInfo: [],    //添加的队员的信息,table2
            total: 0,
            page: 1,
            teamPositionSelectList: [],  //table2身份列表数据
            // 【table数据展示end】

            // 【用于组件传递数据】
            noSystemTeamManInfo: [],  //用于传给副组件非系统成员的数据，当前组件不使用，默认为空
            // 【用于组件传递数据end】

            Editor: Editor,


            page: 1
        }
        // 获取职务列表
        this.getTeamPositionSelectList()
        //获取初始数据
        this.getInitialInfo()


    }

    componentDidMount() {
        this.getApplyinfo()
        this.getExamine()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            // 值发生改变下一步工作
            this.getApplyinfo()
        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            this.getExamine()
        }

    }

    getExamine = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = app.getData('examineInfo');
        // console.log(examineInfo)
        const addTeamPersonInfo = []
        if (examineInfo.volunteer_type == 0) {    //系统人员

            examineInfo.volunteer.forEach(i => {
                const teamPositionSelectInfo = {}
                teamPositionSelectInfo.vname = i.vname
                teamPositionSelectInfo.bsrno = i.bsrno
                teamPositionSelectInfo.teamposition_id = i.teamposition_id
                teamPositionSelectInfo.join_type = i.join_type
                teamPositionSelectInfo.teamname = i.teamname
                teamPositionSelectInfo.indexno = i.indexno
                teamPositionSelectInfo.state = i.state
                teamPositionSelectInfo.teamno = i.original_teamno
                addTeamPersonInfo.push(teamPositionSelectInfo)
            })
            this.setState({
                addTeamPersonInfo
            })
            return

        } else {
            this.setState({
                addTeamPage: 2,
                noSystemTeamManInfo: examineInfo.volunteer
            })
        }

    }




    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = app.getData('applyinfo');
        if (applyinfo.volunteer_type == 0) {    //系统人员
            let addTeamPersonInfo = []
            applyinfo.volunteer.forEach(i => {
                const teamPositionSelectInfo = {}
                teamPositionSelectInfo.vname = i.vname
                teamPositionSelectInfo.bsrno = i.bsrno
                teamPositionSelectInfo.teamposition_id = i.teamposition_id
                teamPositionSelectInfo.join_type = i.join_type
                teamPositionSelectInfo.teamname = i.teamname
                teamPositionSelectInfo.indexno = i.indexno
                teamPositionSelectInfo.state = i.state
                teamPositionSelectInfo.teamno = i.original_teamno
                addTeamPersonInfo.push(teamPositionSelectInfo)
            })
            // console.log(addTeamPersonInfo)

            this.setState({
                addTeamPersonInfo: addTeamPersonInfo,
                addTeamPage: 1
            }, () => {
                console.log(this.state.addTeamPersonInfo)
            })


        } else {
            this.setState({
                addTeamPage: 2,
                noSystemTeamManInfo: applyinfo.volunteer
            })
        }


    }


    teamMemberSource = (e) => {

    }

    //获取初始数据
    getInitialInfo = () => {
        if (this.props.examine == 1 || this.props.apply == 1) {
            return
        }
        const info = app.getData('InitialInfo')
        if (info == undefined) {
            return
        }
        const param = {
            city_id: info.city_id[1],
            teamname: info.teamname,
            mobile: info.mobile,
            name: info.name,
            idno: info.idno,
            sms: info.sms,
        }
        app.post(api.TeamGetInit, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {

                if (res.data.volunteer_type == 0) {
                    const addTeamPersonInfo = []
                    const { volunteer } = res.data
                    volunteer.forEach(i => {
                        const teamPositionSelectInfo = {}
                        teamPositionSelectInfo.vname = i.vname
                        teamPositionSelectInfo.bsrno = i.bsrno
                        teamPositionSelectInfo.teamposition_id = i.teamposition_id
                        teamPositionSelectInfo.join_type = i.join_type
                        teamPositionSelectInfo.teamname = i.teamname
                        teamPositionSelectInfo.indexno = i.indexno
                        teamPositionSelectInfo.state = i.state
                        teamPositionSelectInfo.teamno = i.original_teamno
                        addTeamPersonInfo.push(teamPositionSelectInfo)
                    })
                    this.setState({
                        addTeamPersonInfo
                    })
                } else if (res.data.volunteer_type == 1) {
                    // 1为副组件，属于非系统人员数据
                    this.setState({
                        noSystemTeamManInfo: res.data.volunteer,
                        addTeamPage: 2
                    })
                }
            } else {
                // 获取初始数据失败，验证码失效
                app.alert('验证码已失效，请重新输入', 'error', '45%')
                this.props.setPage(2);
            }
        })

    }

    //获取select队内身份列表信息
    getTeamPositionSelectList = () => {
        app.post(api.TeamPositionSelectList, {}).then(res => {
            if (res.flag == 1) {
                this.setState({
                    teamPositionSelectList: res.data
                })
            }

        })
    }

    //设置暂存
    setCacheVolunteer = async () => {
        const info = app.getData('InitialInfo')
        const volunteer_json = []
        const { addTeamPersonInfo } = this.state;
        // console.log(addTeamPersonInfo)
        addTeamPersonInfo.forEach(i => {
            let memberInfo = {}
            memberInfo.indexno = i.indexno
            memberInfo.join_type = i.join_type,
                memberInfo.teamposition_id = i.teamposition_id,
                memberInfo.original_teamno = i.teamno
            volunteer_json.push(memberInfo)
        })
        // console.log(addTeamPersonInfo)
        const param = {
            area_id: info.city_id[0],
            city_id: info.city_id[1],
            teamname: info.teamname,
            name: info.name,
            idno: info.idno,
            mobile: info.mobile,
            sex: info.sex,
            volunteer_type: 0,
            volunteer_json: JSON.stringify(volunteer_json)
        }
        // console.log(param)
        console.log(param.volunteer_json)
        if (param.volunteer_json == '' || param.volunteer_json.length < 1) {
            return
        }
        app.post(api.TeamSetCacheVolunteer, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                return res
            } else {
                app.alert(res.msg, 'error', '45%')
                return res
            }
        })
    }

    // 动态获取队伍名称(第一个input框)
    onChangeTeamName = value => {
        // if (value.trim() == '') {
        //     return
        // }

        this.setState({
            searchTeamnoValue: value
        })
        // console.log(value)
        if(value.trim() == ''){
            // console.log(value)
            this.setState({
                searchTeamno:'',
                teamList:[]
            },()=>{
                console.log(this.state.searchTeamno)
            })
            return
        }
        const param = {
            search_type: 'searchform_team',
            search_val: value.trim(),
            page: 1
        }
        
        // 1.当用户输入内容时会调用查询接口，将查询到的数据保存在本地
            //搜索了佛山，然后选择了佛山存心救援队选项，然后将这个文本放在了本地
        app.post(api.HomeSearch, param).then(res => {
            // 当用户选择了某一项时，那么会将用户选择的那一项的内容保存在本地 1
            // 当用户点击了搜索，那么就将用户选择的那一项和保存在本地的查询数据进行对比，如果没有发现有相同的内容，那么禁止调用接口
            if (res.flag == 1 && res.msg != "未搜到相关内容") {
                let teamList = []
                let searchTeamno = ''
                res.data.forEach(i => {
                    if (i.teamname.indexOf("（已下架）") == -1) {
                        teamList.push(i.teamname)
                        searchTeamno = i.teamno
                    }

                })

                this.setState({
                    teamList,
                    searchTeamno
                })
            }else{
                // 如果没有发现有相关内容，那么清除缓存内容
                this.setState({
                    teamList:[],
                    searchTeamno:'',
                })
            }
        })
    }

    // 动态获取队员姓名(第二个input框)
    onChangeName = value => {
        // if (value == '') {
        //     return
        // }
        this.setState({
            search_memberval: value
        })
        const param = {
            search_type: 'searchform_name',
            search_val: value.trim(),
            page: 1
        }


        app.post(api.HomeSearch, param).then(res => {
            if (res.flag == 1 && res.msg != "未搜到相关内容") {
                let memberList = []
                res.data.forEach(i => {
                    // console.log(i.bsrno)

                    memberList.push(i.vname + '  ' + '（' + i.bsrno + '）')
                })
                // console.log(memberList)
                this.setState({
                    memberList
                })
            }
        })
    }

    // 搜索队伍input框搜索按钮
    getTeamMember = () => {
        const { searchTeamno, addTeamPersonInfo } = this.state;
        // console.log(searchTeamno)
        // console.log(this.state.teamList)
        //1.当用户输入了内容，但是没有搜索到相关数据，那么将不修改状态searchTeamno
        //2.如果状态searchTeamno为空，那么不允许用户发送请求
        
        if (searchTeamno == '') {
            this.setState({
                // searchTeamnoValue:'',
                data:[]
            })
            return
        }
        this.setState({
            page: 1,
            search_memberval: ''
        })
        
        app.post(api.SearchVolunteer, { type: 1, search: searchTeamno, page: 1 }).then(res => {
            // console.log(res)
            if (res.flag == 1 && res.msg == "获取成功") {


                // 如果初始化有数据
                const data = res.data;
                // 使用已有的队员数据进行循环和获取的数据进行循环对比
                if (addTeamPersonInfo.length > 0) {
                    addTeamPersonInfo.forEach((item, index) => {

                        data.forEach((item2, index2) => {
                            // 如果发现有相同的存心编号，那么说明这个队员已经添加过了，且已被暂存
                            if (item.bsrno == item2.bsrno) {
                                data[index2].flag = 0

                            }
                        })
                    })
                    this.setState({
                        data,
                        total: parseInt(res.total || 0),
                        search_memberval: ''
                    }, () => {
                        this.forceUpdate();
                    })
                } else {
                    this.setState({
                        data,
                        total: parseInt(res.total || 0),
                        search_memberval: ''
                    }, () => {
                        this.forceUpdate();
                    })
                }

            } else {
                app.alert('搜索失败', 'error', '45%')
            }
        })




    }

    // 搜索姓名input框搜索按钮
    getMember = () => {
        const { memberList, addTeamPersonInfo, search_memberval } = this.state;
        // if (searchTeamno == '') {
        //     this.setState({
        //         // searchTeamnoValue:'',
        //         data:[]
        //     })
        //     return
        // }
        if(search_memberval == ''){
            return
        }
        this.setState({
            searchTeamnoValue: '',
            searchTeamno:'',
            data:[]
        })
        
        let end = search_memberval.indexOf('（')
        // console.log(end)
        let vlu
        if (end != -1) {
            vlu = search_memberval.substring(0, end)
        } else {
            vlu = search_memberval
        }
        // console.log(vlu)
        app.post(api.SearchVolunteer, { type: 2, search: vlu.trim(), page: 1, }).then(res => {
            // console.log(res)
            if (res.flag == 1 && res.msg == "获取成功") {


                // 如果初始化有数据
                const data = res.data;
                // console.log(data)
                if (data.length < 1) {
                    app.alert('没有数据', 'error', '45%')
                    return
                }
                // 使用已有的队员数据进行循环和获取的数据进行循环对比
                if (addTeamPersonInfo.length > 0) {
                    addTeamPersonInfo.forEach((item, index) => {

                        data.forEach((item2, index2) => {
                            // 如果发现有相同的存心编号，那么说明这个队员已经添加过了，且已被暂存
                            if (item.bsrno == item2.bsrno) {
                                data[index2].flag = 0

                            }
                        })
                    })
                    this.setState({
                        data,
                        total: parseInt(res.total || 0),
                        searchTeamnoValue: ''


                    }, () => {
                        this.forceUpdate();

                    })
                } else {
                    this.setState({
                        data,
                        total: parseInt(res.total || 0),
                        searchTeamnoValue: ''


                    }, () => {
                        this.forceUpdate();

                    })
                }

            } else {
                app.alert('搜索失败', 'error', '45%')
            }
        })
    }





    // {/* 队员来源 */}
    SourceRadio = (e) => {
        this.setState({
            addTeamPage: e.target.value
        })
    }
    // {/* 队员来源end */}

    // 添加队员
    addTeamMembersInfo = (e) => {
        // console.log(e)
        let addTeamPersonInfo = this.state.addTeamPersonInfo;
        let data = this.state.data;
        addTeamPersonInfo.push(e)
        data.forEach((item, index) => {
            if (item.bsrno == e.bsrno) {
                data[index].flag = 0
            }
        })
        this.setState({
            addTeamPersonInfo
        }, () => {
            console.log(this.state.addTeamPersonInfo)
        })
    }

    //删除添加的队员信息
    deleTeamMembersInfo = (e) => {
        let addTeamPersonInfo = this.state.addTeamPersonInfo;
        // console.log(e)

        let data = this.state.data;
        addTeamPersonInfo.forEach((item, index) => {
            if (item.bsrno == e.bsrno) {
                addTeamPersonInfo.splice(index, 1)
            }
        })
        data.forEach((item, index) => {
            if (item.bsrno == e.bsrno) {
                data[index].flag = undefined
            }
        })
        this.setState({
            addTeamPersonInfo
        }, console.log(this.state.addTeamPersonInfo))
    }

    // select获取队员身份
    SelectState1 = (e, record) => {
        const { addTeamPersonInfo } = this.state;
        // console.log(addTeamPersonInfo)
        // bsrno
        addTeamPersonInfo.forEach((item, index) => {
            if (item.bsrno == record.bsrno) {
                addTeamPersonInfo[index].teamposition_id = e
            }
        })
        this.setState({
            addTeamPersonInfo
        })
        // console.log(addTeamPersonInfo)
    }

    // select获取入队方式
    SelectState2 = (e, record) => {
        const { addTeamPersonInfo } = this.state;
        // console.log(addTeamPersonInfo)
        // bsrno
        addTeamPersonInfo.forEach((item, index) => {
            if (item.bsrno == record.bsrno) {
                addTeamPersonInfo[index].join_type = e
            }
        })
        this.setState({
            addTeamPersonInfo
        })
    }


    setPage = (e) => {
        if (e == 2) {
            this.props.setPage(2)
        } else if (e == 4) {
            this.props.setPage(4)
        }
    }


    tijiao = (e, type) => {
        if (e.length < 1) {
            //当前没有数据
            app.alert('没有队员信息', 'error', '45%')
        } else {
            if (type == 0) {
                let flag = false
                e.forEach((i, v) => {
                    if (i.teamposition_id == undefined) {
                        // console.log(1)
                        app.alert('新增队员未分配队内职务', 'error', '45%')
                        flag = false
                        return
                    }
                    if (i.join_type == undefined) {
                        // console.log(0)
                        app.alert('新增队员未设置入队方式', 'error', '45%')
                        flag = false

                        return
                    }
                    flag = true
                })
                // console.log(flag)
                if (flag) {
                    let volunteer_json = []
                    e.forEach(i => {
                        let memberInfo = {}
                        memberInfo.indexno = i.indexno
                        memberInfo.join_type = i.join_type,
                            memberInfo.teamposition_id = i.teamposition_id,
                            memberInfo.original_teamno = i.teamno
                        volunteer_json.push(memberInfo)
                    })
                    this.props.compon2(volunteer_json, type)
                    this.props.addMember()
                }


            }
            if (type == 1) {
                // console.log(e)
                e.forEach((i, v) => {
                    if (i.name == '') {
                        // console.log(1)
                        app.alert('新增队员未设置姓名', 'error', '45%')
                        return
                    }
                    if (i.mobile == '') {
                        app.alert('新增队员未设置手机号码', 'error', '45%')
                        return
                    }
                    if (i.idno == '') {
                        app.alert('新增队员未设置身份证号码', 'error', '45%')
                        return
                    }
                    if (i.sex == '' || i.sex == undefined) {
                        app.alert('新增队员未设置性别', 'error', '45%')
                        return
                    }
                    if (i.teamposition_id == '' || i.teamposition_id == undefined) {
                        app.alert('新增队员分配队内职务', 'error', '45%')
                        return
                    }
                    this.props.compon2(e, type)
                    this.props.addMember()
                })

            }

            // let 

        }
    }

    next = async () => {
        const { addTeamPersonInfo } = this.state;
        // console.log(addTeamPersonInfo)
        let flag = false
        addTeamPersonInfo.forEach((i, v) => {
            if (i.teamposition_id == undefined) {
                app.alert('新增队员未分配队内职务', 'error', '45%')
                return
            }
            if (i.join_type == undefined) {
                app.alert('新增队员未设置入队方式', 'error', '45%')
                return
            }
            if (v == addTeamPersonInfo.length - 1) {  //判断是否已经循环到了最后一项

                flag = true
            }
        })
        if (flag) {
            const info = app.getData('InitialInfo')
            const volunteer_json = []
            const { addTeamPersonInfo } = this.state;
            // console.log(addTeamPersonInfo)
            addTeamPersonInfo.forEach(i => {
                let memberInfo = {}
                memberInfo.indexno = i.indexno
                memberInfo.join_type = i.join_type,
                    memberInfo.teamposition_id = i.teamposition_id,
                    memberInfo.original_teamno = i.teamno
                volunteer_json.push(memberInfo)
            })
            // console.log(addTeamPersonInfo)
            const param = {
                area_id: info.city_id[0],
                city_id: info.city_id[1],
                teamname: info.teamname,
                name: info.name,
                idno: info.idno,
                mobile: info.mobile,
                sex: info.sex,
                volunteer_type: 0,
                volunteer_json: JSON.stringify(volunteer_json)
            }
            console.log(param)

            if (param.volunteer_json == '' || param.volunteer_json.length < 1) {
                return
            }
            app.post(api.TeamSetCacheVolunteer, param).then(res => {
                // console.log(res)
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.props.setPage(4)
                } else {
                    app.alert(res.msg, 'error', '45%')
                    return res
                }
            })
        }

    }


    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setState({ page })
        let { dataType, search_type, search_val, searchTeamno, search_memberval, addTeamPersonInfo } = this.state, params = {
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 1,
        }
        if (searchTeamno != '') {
            params.type = 1
            params.search = searchTeamno
        } else if (search_memberval != '') {
            params.type = 2
            params.search = search_memberval
        }
        let { flag, data, msg, total } = await app.post(api.SearchVolunteer, params)
        // console.log(data)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }

        if (addTeamPersonInfo.length > 0) {
            addTeamPersonInfo.forEach((item, index) => {

                data.forEach((item2, index2) => {
                    // 如果发现有相同的存心编号，那么说明这个队员已经添加过了，且已被暂存
                    if (item.bsrno == item2.bsrno) {
                        data[index2].flag = 0

                    }
                })
            })
            this.setState({
                data,
                total: parseInt(total || 0),
            })
        } else {
            this.setState({
                data,
                total: parseInt(total || 0),
            })
        }

    }

    // 页面渲染区
    render() {
        let { addTeamPage, addTeamPersonInfo, data, teamList, memberList, noSystemTeamManInfo, teamPositionSelectList, total, page } = this.state



        const columns = [

            {
                title: '姓名',
                width: 100,
                dataIndex: 'vname',
                key: 'vname',
            },
            {
                title: '存心编号',
                width: 100,
                dataIndex: 'bsrno',
                key: 'bsrno',
            },
            {
                title: '转出队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: 150,

            },
            {
                title: '队员身份',
                dataIndex: 'state',
                width: 225,
                key: 'state',
            },
            {
                title: '队内职务',
                dataIndex: 'teamposition',
                width: 325,
                key: 'teamposition',
            },
            {
                title: '操作',
                key: 'operation',
                width: 100,
                render: (record) => <div>
                    {record.flag == undefined ? <Button onClick={() => this.addTeamMembersInfo(record)} style={{ backgroundColor: '#1890FF', color: '#fff' }}>添加</Button> : <Button >已添加</Button>}
                </div>,
            },
        ];


        //{/* 搜索队员信息展示列表end */ }

        //{/* 申请筹备组队员信息如下 */ }
        const content2 = (
            <div style={{ wordWrap: 'break-word', width: 300 }}>
                <div style={{ marginBottom: 30 }}>转队：转队代表队员从A队转到B队，转队时系统会给队员在新队伍重新生成新的存心编号；转队之后，队员在原来队伍的身份属于离队状态，原来队伍的队内职位和权限不保留，需要新队伍管理员重新分配队内职位、身份、权限</div>

                <p>加入：加入队伍代表一个队员同时属于多个队伍，不同队伍可以设置不同队内职位</p>
            </div>
        )

        const columns2 = [

            {
                title: '姓名',
                width: 100,
                dataIndex: 'vname',
                key: 'vname2',
            },
            {
                title: '存心编号',
                width: 100,
                dataIndex: 'bsrno',
                key: 'bsrno2',
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname2',
                width: 200,

            },
            {
                title: '队员身份',
                dataIndex: 'state',
                width: 200,
                key: 'state2',
            },
            {
                title: '分配队内职务',
                key: 'teamposition_id2',
                width: 200,
                render: (record) => <div>
                    <Select placeholder="请选择" style={{ width: 150 }} filterOption={false} onChange={(e) => this.SelectState1(e, record)} value={record.teamposition_id} disabled={this.props.examine == 1 || this.props.detailF == 1}>

                        {teamPositionSelectList.map((item, index) =>
                            <Option key={item.id} value={item.id}
                                disabled={record.state == '队员'
                                    ? (item.name == '志愿者' || item.name == '预备队员' ? true : false)
                                    :
                                    (record.state == '志愿者'
                                        ? (item.name == '队员' || item.name == '预备队员' ? true
                                            : false)
                                        :
                                        (record.state == '预备队员'
                                            ? (item.name == '队员' || item.name == '志愿者' ? true : false)
                                            : false))}
                            //如果当前是队员的话，那么不允许点击志愿者和预备队员
                            >{item.name}</Option>
                        )}
                    </Select>
                </div>,
            },
            {
                title: <div>入队方式&nbsp;
                        <Popover content={content2} >
                        <Icon type="question-circle" style={{ color: '#F2A51D', fontSize: 16 }} />
                    </Popover>
                </div>,
                key: 'operation1',
                width: 200,
                render: (record) => <div>
                    <Select placeholder="请选择" style={{ width: 150 }} onSelect={(e) => this.SelectState2(e, record)} value={record.join_type} disabled={this.props.examine == 1 || this.props.detailF == 1}>
                        <Option value="0">加入</Option>
                        <Option value="1">转队</Option>

                    </Select>
                </div>,
            },
            {
                title: '操作',
                key: 'operation2',
                width: 100,
                render: (record) => <div hidden={this.props.examine == 1 || this.props.detailF == 1}>
                    <Button onClick={() => this.deleTeamMembersInfo(record)}>移除</Button>
                </div>,
            },
        ];


        //{/* 申请筹备组队员信息如下 */ }

























        let component_node = null


        const content = (
            <div>
                <p>系统人员：指队员本身已加入存心救援队，并且队员信息已录入存心救援信息公开平台</p>
                <p>非系统人员：指队员本身尚未加入存心救援队或队员信息未录入存心救援信息公开平台</p>
            </div>
        )

        const AddSystemPerson = (
            <div >
                <div style={{ marginBottom: 20 }}>
                    {/* 根据搜索条件搜索队员 */}
                    {
                        this.props.examine == 1 || this.props.detailF == 1 ? '' : <div style={{ display: "flex" }}>

                            <div style={{ marginTop: 20 }}>

                                <AutoComplete
                                    style={{ height: 50, width: 200, }}
                                    dataSource={teamList}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.includes(inputValue)
                                    }
                                    onChange={this.onChangeTeamName}
                                    placeholder="根据队伍名称搜索队员"
                                    value={this.state.searchTeamnoValue}

                                />
                                <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.getTeamMember}>搜索</Button>
                                {/* 这里不需要请求，只需要将所有队伍都拿到并放到companyList中即可，当用户选择了某个队伍从onselect中得到这个队伍的名称 */}
                                {/* 拿到这个名称后将名称放入state中，用户点击搜索按钮后就请求这个队伍的所有队员 */}
                            </div>

                            <div style={{ marginTop: 20, marginLeft: 40, width: 500 }}>

                                <AutoComplete
                                    style={{ height: 50, width: 200 }}
                                    dataSource={memberList}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.includes(inputValue)
                                    }
                                    onChange={this.onChangeName}
                                    placeholder="根据队员姓名搜索队员"
                                    value={this.state.search_memberval}


                                />
                                <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.getMember}>搜索</Button>

                            </div>

                        </div>
                    }
                    {/* 根据搜索条件搜索队员end */}

                    {/* 搜索队员信息展示列表 */}
                    <div style={{ fontSize: 16, paddingTop: 10 }} hidden={this.props.examine == 1 || this.props.detailF == 1}>
                        <p>搜索队员信息如下：</p>
                        <div>
                            <Table columns={columns} rowKey={'searchMember'} dataSource={data} scroll={{ y: 300 }}
                                rowKey={record => record.id}
                                pagination={false}
                                footer={() => {
                                    return (
                                        <Row hidden={data.length === 0}>
                                            <Col span={24} style={{ textAlign: 'right' }}>
                                                <Pagination total={total} size="small" pageSize={20} current={page}
                                                    showTotal={(total) => `总数量：${total}`}
                                                    onChange={this.dataSource} />
                                            </Col>
                                        </Row>
                                    )
                                }} />
                        </div>
                    </div>
                    {/* 搜索队员信息展示列表end */}


                    {/* 申请筹备组队员信息如下 */}
                    <div style={{ fontSize: 16, paddingTop: 10 }}>
                        <p>申请筹备组队员信息如下：</p>
                        <div>
                            <Table columns={columns2} dataSource={addTeamPersonInfo} scroll={{  y: 400 }} rowKey={record => record.id} />
                        </div>
                    </div>
                    {/* 申请筹备组队员信息如下end */}

                    {/* 提醒 */}
                    <div style={{ fontSize: 14, paddingTop: 10, color: '#FB6519' }} hidden={this.props.examine == 1 || this.props.detailF == 1}>
                        <p>注：务必填写真实有效的队员信息</p>
                    </div>
                    {/* 提醒end */}

                </div>

                {/* 功能按钮 */}
                <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} hidden={this.state.Editor == 2}>
                    <Button style={{ width: 300, marginRight: 50 }} onClick={() => this.props.setPage(2)}>上一步</Button>
                    {/* onClick={this.golast} */}
                    <Button style={{ width: 300, }} onClick={this.setCacheVolunteer}>暂存</Button>
                    {/* onClick={this.setNowAllData} */}
                    <Button style={{ width: 300, marginLeft: 50, backgroundColor: '#1890FF', color: '#fff' }} onClick={() => this.next()}>下一步</Button>
                    {/* onClick={this.goNext} */}
                </div>
                {/* 功能按钮end */}

                {/* 功能按钮 */}
                <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} >

                    {
                        this.props.examine == 1 || this.props.detailF == 1 ? '' : this.state.Editor == 2 ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff', }} onClick={() => this.tijiao(this.state.addTeamPersonInfo, 0)}>提交队员信息</Button> : ''
                    }
                </div>
                {/* 功能按钮end */}



            </div>
        )
        switch (addTeamPage) {
            case 1:
                component_node = (AddSystemPerson)
                break
            case 2:
                component_node = (<AddNoSystemPerson noSystemTeamManInfo={noSystemTeamManInfo} setPage={this.props.setPage} Editor={this.state.Editor} tijiao={this.tijiao} examine={this.props.examine} detailF={this.props.detailF} com2={this.props.com2} />)
                break
        }

        return (

            <div>
                {/* 标题 */}
                <h3 style={{ fontWeight: 'bold', fontSize: 18 }}>
                    {this.props.examine == 1 || this.props.detailF == 1 ? '队员信息' : '添加队员信息'}
                </h3>
                {/* 标题end */}

                {/* 队员来源 */}
                <div style={{ fontSize: 16, paddingTop: 10 }}>
                    <span style={{ color: 'red' }}>*</span>
                        队员来源：
                        <RadioGroup options={[
                        { label: '系统人员', value: 1 },
                        { label: '非系统成员', value: 2 },
                    ]}
                        value={addTeamPage} onChange={this.SourceRadio}
                        disabled={this.props.examine == 1 || this.props.detailF == 1}
                    />
                    <Popover content={content} >

                        <Icon type="question-circle" style={{ color: '#F2A51D', fontSize: 16 }} />
                    </Popover>
                </div>
                {/* 队员来源end */}
                {component_node}
            </div>

        )
    }
}



export default AddTeamMembers



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/AddTeamMembers.jsx